<div class="p-5">
  <div class="d-flex justify-content-center align-items-center">
    <div class="terms">
      <div [innerHTML]="terms"></div>
    </div>
  </div>
</div>
